"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperAbtract = void 0;
var HelperAbtract = /** @class */ (function () {
    function HelperAbtract() {
        // 保持 X-Client-Request-ID 中间参数不随意变
        this.sessionId = this.generateRandomString(6, 16);
        this.device_id = '';
    }
    HelperAbtract.prototype.getDeviceId = function () {
        return '';
    };
    HelperAbtract.prototype.getAiServerHeaders = function () {
        return {};
    };
    HelperAbtract.prototype.getAiServerHeadersV5 = function () {
        return {};
    };
    HelperAbtract.prototype.getObjKeysMerged = function (originObj, newObj) {
        if (!originObj || Object.keys(originObj).length === 0) {
            return newObj;
        }
        if (!newObj || Object.keys(newObj).length === 0) {
            return originObj;
        }
        var mergedObj = __assign({}, originObj);
        // sdk存在相同key则被覆盖，没有就保留
        Object.keys(newObj).forEach(function (key) {
            var lowerCaseKey = key.toLowerCase();
            if (mergedObj[lowerCaseKey]) {
                mergedObj[lowerCaseKey] = newObj[key];
            }
            else {
                mergedObj[key] = newObj[key];
            }
        });
        return mergedObj;
    };
    /**
     * 生成随机字符串
     * @param length 字符串长度
     * @param radix 进制
     * @returns
     */
    HelperAbtract.prototype.generateRandomString = function (length, radix) {
        if (radix < 2 || radix > 36) {
            throw new Error('基数必须在2到36之间');
        }
        var result = '';
        // 根据所需长度和进制，生成足够长的随机字符串
        while (result.length < length) {
            // 生成一个随机数，并转换为指定基数的字符串
            var randomStr = Math.random().toString(radix).substring(2);
            // 拼接生成的字符串
            result += randomStr;
        }
        // 长度可能超出所需，进行截断
        result = result.substring(0, length);
        return result;
    };
    HelperAbtract.prototype.genClientRequestId = function () {
        return this.getClientRequestId();
    };
    HelperAbtract.prototype.getClientRequestId = function () {
        return "".concat(Date.now(), "_").concat(this.sessionId, "_").concat(this.generateRandomString(12, 16));
    };
    // 兼容名称错误问题
    HelperAbtract.prototype.genActionId = function () {
        return this.getActionId();
    };
    HelperAbtract.prototype.getActionId = function () {
        return this.generateRandomString(32, 16);
    };
    return HelperAbtract;
}());
exports.HelperAbtract = HelperAbtract;
